import {Request} from '../index.js'

/**
 * 登录
 *
 * @param params
 * @returns {*|Promise|Promise<any>|Window.Promise}
 */
export function login(params) {
    return Request.post("/auth/token", params);
}

/**
 * 退出登录
 *
 * @returns {*|Promise|Promise<any>|Window.Promise}
 */
export function logout() {
    return Request.delete("/auth/token");
}

